define('StockStatusTags.Checkout',
  [
    'StockStatusTags.Utils',
    'StockStatusTags.View',
    'Header.MiniCartItemCell.View',
    'Transaction.Line.Views.Cell.Navigable.View'
  ],
  function (
    StockStatusTagsUtils,
    StockStatusTagsView,
    HeaderMiniCartItemCellView,
    TransactionLineViewsCellNavigableModule
  ) {
    'use strict';

    var TransactionLineViewsCellNavigableView =
      TransactionLineViewsCellNavigableModule.TransactionLineViewsCellNavigableView ||
      TransactionLineViewsCellNavigableModule;

    function lineTagsChildView() {
      return new StockStatusTagsView({
        model: this.model,
        buildItemTags: StockStatusTagsUtils.buildItemTags
      });
    }

    return {
      mountToApp: function mountToApp() {
        HeaderMiniCartItemCellView.addChildViews({
          'StockStatusTags.MiniCart': lineTagsChildView
        });

        TransactionLineViewsCellNavigableView.addChildViews({
          'StockStatusTags.Checkout': lineTagsChildView
        });
      }
    };
  }
);
